import { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Collapse, Modal, Row } from 'reactstrap';
import { IConfig, INotification, IUserDetail, IUserNotification } from 'src/services/types';
// import "react-image-lightbox/style.css";
import { Spinner } from 'src/components/Common/Spinner';
import { fetchUserWhomNotificationWasSent } from 'src/services/notification-manage-service';
import { toast } from 'react-toastify';
import { SearchTable } from 'src/components/Common/SearchTable';
import { ContentDataTable } from 'src/components/Common/ContentDataTable';
import DataTable from 'react-data-table-component';
import { SectionNoData } from 'src/components/Common/SectionNoData';
import { columnsUsersWhomNotification } from './ColumnsUsersWhomNotification';
import { StatusUserNotificationFilter } from './StatusUserNotificationFilter';

interface IProps {
    show: boolean;
    onClose: () => void;
    notification: INotification;
} 

export const UsersWhomNotificationWasSent = ({ 
    show, 
    onClose, 
    notification, 
}: IProps) => {
    
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [searchLoading, setSearchLoading] = useState(false);
    const [users, setUsers] = useState<IUserNotification[]>([]);
    const [config, setConfig] = useState<IConfig>({
        page: 1,
        per_page: 10,
        search: "",
        sent: null, // null, true (success), false (failed)
    });
  
    const fetchUsersNotification = async () => {
        if(!notification?.id) return;
        setLoading(true);
        const res = await fetchUserWhomNotificationWasSent(config, notification?.id, null);
        console.log('res users whom notification was sent:', res);
        if (res.result === "ok") {
            setUsers(res.data?.data || []);
            setTotalRows(res.data?.pagination?.total || 0);

        } else {
            toast.error(res.message || "Error fetching users");
        }
        setLoading(false);
    }

    const handleChangeStatusFilter = (value: string) => {
        let statusValue: null|boolean = null;
        if(value === 'true') {
        statusValue = true;
        }
        if(value === 'false') {
        statusValue = false;
        } 
        if(value === 'all') {
        statusValue = null;
        }

        setConfig({ ...config, sent: statusValue, page: 1 });
    }

    useEffect(() => {
        if(notification?.id){
            fetchUsersNotification();
        } else {
            setConfig((prev) => ({ ...prev, sent: null }));
        }
    }, [notification?.id]);

    useEffect(() => {
        fetchUsersNotification();
    }, [config]);

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        size='xl'   
    >
        {
            <div>
                <div className="modal-header">
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <h5 className="modal-title" id="staticBackdropLabel">
                            Users
                        </h5>
                        <button
                            type="button"
                            className="btn-close pr-5"
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <div className="modal-body">
                    <div>
                        <Card className='mb-3'>
                            <CardBody>
                                <Row>
                                    <Col sm={12} className='d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center gap-2'>
                                        <div>
                                            <h6 className='m-0'>{notification?.title}</h6>
                                            <small className='text-muted'>Sent at: {notification?.created_at}</small>
                                        </div>
                                        <div>
                                            <p className='m-0'>{notification?.body}</p>
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </div>
                    <div className="">
                        <Row className="mb-2">
                            <Col sm={6} className="d-flex align-items-center justify-content-start gap-2">
                                <Row className="mb-2">
                                    <Col sm={12} md={6} className=" d-flex align-items-end" >
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-soft-primary waves-effect waves-light"
                                                onClick={fetchUsersNotification}
                                            >
                                                <i className="fas fa-sync-alt"></i> Refresh
                                            </button>
                                        </div>
                                    </Col>
                                    <Col sm={12} md={6} className="d-flex align-items-center" >
                                        <div className="d-flex align-items-center ">
                                            <StatusUserNotificationFilter
                                                onChange={handleChangeStatusFilter}
                                                label="Status"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={12} md={12} lg={6} className="d-flex align-items-end justify-content-end" >
                                <div className="">
                                    <SearchTable 
                                        onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                                        loading={searchLoading && !!config.search}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <ContentDataTable isLoading={searchLoading}>
                            <DataTable
                                customStyles={{
                                    rows: { style: { minHeight: '45px' }},
                                    table: { style: { minHeight: '400px'}},
                                    cells: { style: { paddingLeft: '8px', paddingRight: '8px' }},
                                }}
                                columns={columnsUsersWhomNotification(config)}
                                data={users}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                responsive
                                onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                                onChangePage={(page) => setConfig({ ...config, page })}
                                paginationDefaultPage={config.page}
                                paginationPerPage={config.per_page}
                                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                noDataComponent={
                                    <SectionNoData
                                        onRefresh={() => fetchUsersNotification()}
                                        isLoading={searchLoading}
                                    />
                                }
                            />
                        </ContentDataTable>
                    </div>
                </div>

                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={onClose}>
                        Ok
                    </button>
                </div>

                {
                    loading &&
                    <div style={{ position: 'absolute', backgroundColor: 'rgba(255, 255, 255, 0.7)', top: 0, left: 0, right: 0, bottom: 0, borderRadius: '8px' }} className="d-flex align-items-center justify-content-center">
                        <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', padding: '10px', borderRadius: '8px' }}>
                            <Spinner text='Loading user...'/>
                        </div>
                    </div>
                }
            </div>
        }
    </Modal>
  )
}
